import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { select } from '@ngxs/store';
import { AccountState } from '@shared/states/account.state';
import { isEskoHostname } from '@shared/utilities/branding.utilities';

@Component({
  selector: 'brand-icon',
  templateUrl: './brand-icon.component.html',
  styleUrls: ['./brand-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BrandIcon {
  @Input()
  @HostBinding('class')
  class: string;

  @Input()
  invert: boolean = false;

  isEsko = isEskoHostname();

  readonly parentBranding = select(AccountState.parentBranding);
}
